﻿import { Component} from '@angular/core';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {


    constructor( ) {}

    currentYear(): number {
        return (new Date()).getFullYear();
    }

}
